import { gql } from '@apollo/client';

export default gql`
  query getMessagesBefore($count: Int!, $messageId: ID!, $channelId: ID!) {
    messagesBefore(
      count: $count
      messageId: $messageId
      channelId: $channelId
    ) {
      hasMore
      channelId
      messages {
        id
        parent
        creator {
          id
          picture
          name
        }
        createdAt
        text
        formatted
        tags {
          id
          kind
          state
        }
        analysis {
          id
          display
          start
          end
        }
        annotation {
          url
          imageUrl
        }
      }
    }
  }
`;
